export default Object.freeze({
  /**
   * Booking does not exist
   */
  bookingDoesNotExist: 'booking_does_not_exist',
  /**
   * User is not authorized to view the booking
   */
  bookingUnauthorised: 'user_not_authorized_to_view_booking',
  /**
   * Multi-tentative has been filled by another candidate
   */
  bookingAlreadyFilled: 'booking_already_filled',
  /**
   * Candidate is unavailable for booking due to conflict with existing booking
   */
  candidateUnavailableForBooking: 'candidate_unavailable_for_booking',
  /**
   * Booking is not tentative
   */
  bookingIsNotTentative: 'booking_is_not_tentative',
  /**
   * Tentative booking has already been rejected
   */
  bookingRejected: 'booking_tentative_already_rejected',
})
